import { GET_THIRD_PARTY_LIST, CREATE_ACCOUNT, EDIT_ACCOUNT, DISABLE_EDIT, VERIFY_THIRD_PARTY_ACCOUNT_OTP, RESEND_THIRD_PARTY_ACCOUNT_OTP, CLEAR_THIRD_PARTY_ACCOUNT_OTP } from './actions';

import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';

const defaultState = {
  thirdPartyList: [],
  accountCreated: false,
  accountEdited: false,
  editDisabled: false,
  thirdPartyAccountOtpDetails: null,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_THIRD_PARTY_LIST[REQUEST]:
      return { ...state };
    case GET_THIRD_PARTY_LIST[SUCCESS]:
      return { ...state, thirdPartyList: action.response };
    case CREATE_ACCOUNT[REQUEST]:
      return { ...state, accountCreated: false, thirdPartyAccountOtpDetails: null };
    case CREATE_ACCOUNT[SUCCESS]:
      // Check if OTP is required
      if (action.response && action.response.otpRequired === true) {
        return {
          ...state,
          accountCreated: false,
          thirdPartyAccountOtpDetails: {
            otpRequired: true,
            otpId: action.response.otpId,
            otpSendTo: action.response.otpSendTo,
            accountData: action.requestPayload,
            isEdit: false,
          },
        };
      }
      return { ...state, accountCreated: true, thirdPartyAccountOtpDetails: null };
    case EDIT_ACCOUNT[REQUEST]:
      return { ...state, accountEdited: false, thirdPartyAccountOtpDetails: null };
    case EDIT_ACCOUNT[SUCCESS]:
      // Check if OTP is required
      if (action.response && action.response.otpRequired === true) {
        return {
          ...state,
          accountEdited: false,
          thirdPartyAccountOtpDetails: {
            otpRequired: true,
            otpId: action.response.otpId,
            otpSendTo: action.response.otpSendTo,
            accountData: action.requestPayload,
            isEdit: true,
          },
        };
      }
      return { ...state, accountEdited: true, thirdPartyAccountOtpDetails: null };
    case DISABLE_EDIT[REQUEST]:
      return { ...state, editDisabled: false };
    case DISABLE_EDIT[SUCCESS]:
      return { ...state, editDisabled: true };
    case VERIFY_THIRD_PARTY_ACCOUNT_OTP[REQUEST]:
      return { ...state, accountCreated: false, accountEdited: false };
    case VERIFY_THIRD_PARTY_ACCOUNT_OTP[SUCCESS]:
      // Handle third party account OTP verification
      if (state.thirdPartyAccountOtpDetails) {
        const isEdit = state.thirdPartyAccountOtpDetails?.isEdit || false;
        return {
          ...state,
          accountCreated: !isEdit,
          accountEdited: isEdit,
          thirdPartyAccountOtpDetails: null,
        };
      }
      return state;
    case VERIFY_THIRD_PARTY_ACCOUNT_OTP[FAILURE]:
      return {
        ...state,
        accountCreated: false,
        accountEdited: false,
      };
    case RESEND_THIRD_PARTY_ACCOUNT_OTP[REQUEST]:
      return { ...state };
    case RESEND_THIRD_PARTY_ACCOUNT_OTP[SUCCESS]:
      return { ...state };
    case RESEND_THIRD_PARTY_ACCOUNT_OTP[FAILURE]:
      return { ...state };
    case CLEAR_THIRD_PARTY_ACCOUNT_OTP:
      return { 
        ...state, 
        thirdPartyAccountOtpDetails: null,
      };
    default:
      return state;
  }
}

export const getThirdPartyList = (state) => state.thirdParty.thirdPartyList;
export const getThirdPartyReducer = (state) => state.thirdParty;
